import { useMutation } from 'react-query'
import { postJSON } from 'common/services/api'
import { DeviceItemResponse, DeviceUpdateRequest } from '@lmc/ts-common'
import { handleErrorResponse } from 'utils/error'

const useUpdateDeviceById = (onSuccess?: () => void) => {
  const mutationFunction = (
    body: DeviceUpdateRequest & { id?: string }
  ): Promise<{ result: DeviceItemResponse }> =>
    postJSON({
      url: `list/devices/${body?.id}`,
      json: body,
      method: 'PATCH',
    })

  const { mutateAsync, isLoading, error, reset } = useMutation(
    mutationFunction,
    {
      onSuccess,
    }
  )

  return {
    isLoading,
    updateDevice: mutateAsync,
    error: handleErrorResponse(error),
    reset,
  }
}

export default useUpdateDeviceById
